import { render } from "./Edit.vue?vue&type=template&id=8b4f8740&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=8b4f8740&scoped=true&lang=css"

import exportComponent from "/var/www/html/tsk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b4f8740"]])

export default __exports__